export const GENERIC_LABELS = {
  cancelWindowModalTitle: 'Cancelar ventana',
  cancelAgendaModalTitle: 'Cancelar agendamiento',
  approveAgendaModalTitle: 'Aprobar agendamiento',
  cancelWindowModalBody: 'Desea cancelar la solicitud?',
  approveAgendaModalBody: 'Desea aprobar la solicitud?',
  buttonCancel: 'Cancelar ',
  buttonConfirm: 'Confirmar',
};
